import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarCheck, CheckCircle, XCircle, Question } from "@phosphor-icons/react";
import { rcApi, RC, errMsg } from "./rcApi";
import { RcCard, RcTitle, Tag } from "./rcUi";

export const fmtDate = (d) => (d ? new Date(`${d}T12:00:00`).toLocaleDateString("fr-CA", { weekday: "long", day: "numeric", month: "long" }) : "");
export const meetingLabel = (mt, settings) => mt
  ? `${fmtDate(mt.date)}${mt.heure ? ` · ${mt.heure}` : ""}`
  : settings?.prochaine_date ? `${settings.prochaine_date}${settings.prochaine_heure ? ` · ${settings.prochaine_heure}` : ""}` : "Date à confirmer";

const OPTS = [["oui", "J'y serai", CheckCircle, RC.turquoise], ["peut_etre", "Peut-être", Question, RC.gold], ["non", "Pas cette fois", XCircle, RC.muted]];

export function Rencontres() {
  const [d, setD] = useState(null);
  const load = () => rcApi.get("/rencontres").then((r) => setD(r.data)).catch(() => setD({ rencontres: [], presences: 0 }));
  useEffect(() => { load(); }, []);
  if (!d) return null;
  const avenir = d.rencontres.filter((m) => !m.passee), passees = d.rencontres.filter((m) => m.passee).reverse();
  const answer = async (m, reponse) => {
    try { await rcApi.post(`/rencontres/${m.id}/rsvp`, { reponse }); toast.success(reponse === "oui" ? "Merci, à bientôt !" : "Réponse enregistrée"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section data-testid="rc-rencontres">
      <RcTitle kicker="Mes rencontres">Calendrier et présences</RcTitle>
      {!avenir.length && <p className="text-sm mb-3" style={{ color: RC.muted }}>Aucune rencontre planifiée pour l'instant — la date sera annoncée ici.</p>}
      <div className="space-y-3">
        {avenir.map((m) => (
          <RcCard key={m.id} data-testid={`rc-meeting-${m.id}`}>
            <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
              <CalendarCheck size={22} color={RC.coral} className="self-center" />
              <span className="font-bold capitalize">{fmtDate(m.date)}</span>
              {m.heure && <span style={{ color: RC.muted }}>{m.heure}</span>}
              <Tag>Rencontre {m.numero}</Tag>
            </div>
            <div className="text-sm mt-1" style={{ color: RC.muted }}>{m.lieu}{m.note ? ` — ${m.note}` : ""}</div>
            <div className="grid grid-cols-3 gap-2 mt-4">
              {OPTS.map(([k, label, Icon, color]) => {
                const on = m.ma_reponse === k;
                return (
                  <button key={k} onClick={() => answer(m, k)} data-testid={`rc-rsvp-${m.id}-${k}`} className="rounded-xl px-2 py-2.5 text-sm font-semibold border flex items-center justify-center gap-1.5"
                    style={{ borderColor: on ? color : RC.line, color: on ? color : RC.muted, background: on ? color + "22" : "transparent" }}>
                    <Icon size={16} weight={on ? "fill" : "regular"} />{label}
                  </button>
                );
              })}
            </div>
          </RcCard>
        ))}
      </div>
      {passees.length > 0 && (
        <RcCard className="mt-4" data-testid="rc-historique">
          <div className="flex items-baseline justify-between mb-2"><span className="font-bold">Mon historique</span><span className="text-sm" style={{ color: RC.turquoise }}>{d.presences} présence{d.presences > 1 ? "s" : ""}</span></div>
          <ul className="divide-y text-sm" style={{ borderColor: RC.line }}>
            {passees.map((m) => (
              <li key={m.id} className="py-2 flex items-center justify-between gap-3">
                <span className="capitalize">{fmtDate(m.date)} <span style={{ color: RC.muted }}>· Rencontre {m.numero}</span></span>
                <span style={{ color: m.present === true ? RC.turquoise : m.present === false ? RC.muted : RC.gold }}>{m.present === true ? "Présent·e" : m.present === false ? "Absent·e" : m.ma_reponse ? "Réponse : " + (OPTS.find((o) => o[0] === m.ma_reponse)?.[1] || m.ma_reponse) : "—"}</span>
              </li>
            ))}
          </ul>
        </RcCard>
      )}
    </section>
  );
}
